<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" lg="6" class="d-flex align-center">
            <div>
              <h1 class="title font-weight-light mb-lg-1">
                <v-icon class="mb-1" left>mdi-format-list-bulleted </v-icon>
                {{ $t("ORDERS.ORDERLIST.TITLE") }}
              </h1>
              <div class="pr-lg-15 mb-1"></div>
              <p class="text-caption font-weight-light mb-0">
                {{ $t("ORDERS.ORDERLIST.SUBTITLE") }}
              </p>
            </div>
          </v-col>
          <v-col cols="12" lg="6" class="d-flex align-end">
            <v-row class="mx-0">
              <v-col cols="12" lg="3" class="px-0 px-lg-2">
                <v-select
                  solo
                  dense
                  item-text="name"
                  item-value="name"
                  class="font-weight-light"
                  :label="$t('ORDERS.SELECTBOX.SEARCHALL')"
                  clearable
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" lg="9" class="px-0">
                <v-text-field
                  solo
                  :hint="$t('ORDERS.SELECTBOX.HINT')"
                  dense
                  :label="$t('ORDERS.SELECTBOX.LABEL')"
                  prepend-inner-icon="mdi-magnify"
                  class="urun-ara-text-field font-weight-light"
                  clearable
                >
                  <template v-slot:append>
                    <v-btn depressed icon class="urun-ara-btn">
                      <v-icon color="black">mdi-chevron-right</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-data-table v-model="selectionSiparisler" :headers="headers" :items="siparisListesi">
          <template v-slot:[`item.resimler`]>
            <img :src="`${$apiImagesUrl}/urunler/origin/shoe.png`" width="70" />
          </template>
          <template v-slot:[`item.name`]="{ item }">
            <strong>{{ item.name }}</strong>
          </template>
          <template v-slot:[`item.renk`]="{ item }">
            <v-sheet width="30px" height="20px" :color="item.renk" rounded></v-sheet>
          </template>
          <template v-slot:[`item.fiyat`]="{ item }">
            <div class="d-flex text-caption">
              <strong>{{ formatFiyat(item.fiyat) }}</strong>
              <v-icon small color="primary" class="ml-1">mdi-currency-try </v-icon>
            </div>
          </template>
          <template v-slot:[`item.durum`]="{ item }">
            <v-chip color="yellow" class="text-caption" v-if="item">{{ $t("ORDERS.LIST.STATUS_W_FOR_APPRV") }}</v-chip>
          </template>
          <template v-slot:[`item.actions`]>
            <v-btn x-small color="primary">
              {{ $t("ORDERS.LIST.ACTION_UPDATE") }}
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "SiparisList",
  data() {
    return {
      selectionSiparisler: [],
      headers: [
        {
          text: this.$t("ORDERS.TABLE.CODE"),
          align: "start",
          sortable: false,
          value: "kod"
        },
        { text: this.$t("ORDERS.TABLE.PREVIEW"), value: "resimler", sortable: false },
        { text: this.$t("ORDERS.TABLE.TITLE"), value: "name", sortable: false },
        { text: this.$t("ORDERS.TABLE.COLOR"), value: "renk", sortable: false },
        { text: this.$t("ORDERS.TABLE.PRICE"), value: "fiyat", sortable: false },
        { text: this.$t("ORDERS.TABLE.STATUS"), value: "durum", sortable: false },
        { text: this.$t("ORDERS.TABLE.ACTIONS"), value: "actions", sortable: false }
      ],
      siparisListesi: [
        {
          id: "59",
          name: "Men's Timberland 6 In. Premium Boot Black",
          link: "Men's Timberland 6 In. Premium Boot Black",
          node: "1",
          category: "Günlük",
          lang: "tr_TR",
          code: "58",
          date: "2021-01-28 22:44:03",
          kod: "5235235",
          renk: "#000000",
          fiyat: "599.99",
          stok: { "#000000": "300", "#3E2723FF": "3466" },
          boyut: "42",
          resimler: {
            "#000000": ["urun-28-01-2021-1611863043-01.jpg", "urun-28-01-2021-1611863043-00.jpg", "urun-28-01-2021-1611863043-02.jpg"],
            "#3E2723FF": ["urun-28-01-2021-1611863043-10.jpg"]
          },
          aciklama:
            "&lt;p&gt;Marka:&amp;nbsp;Mehmet Mete&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&lt;/p&gt;&lt;p&gt;Mensei: Türkiye&lt;/p&gt;&lt;p&gt;Model:&amp;nbsp; Günlük Erkek Bot&lt;/p&gt;&lt;p&gt;Sezon: Kış&lt;/p&gt;&lt;p&gt;&amp;nbsp;&lt;/p&gt;&lt;p&gt;Materyal:&lt;/p&gt;&lt;p&gt;Dış Materyal: Hakiki Deri&lt;/p&gt;&lt;p&gt;İç Materyal: Yünlü Sıcak Astar&lt;/p&gt;&lt;p&gt;Bağlama Sekli: FERMUARLI BAĞÇIKLI&lt;/p&gt;&lt;p&gt;Taban Bilgisi :&amp;nbsp; TERMO KAUÇUK&lt;/p&gt;&lt;p&gt;Kalıp Bilgisi:&amp;nbsp;&amp;nbsp;Standart Kalıp&lt;/p&gt;",
          durum: "1"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      // siparisListesi: state => state.Siparisler.SiparisList.siparisListesi
    })
  },
  methods: {
    formatFiyat(fiyat) {
      var formatter = new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "TRY"
      });
      return formatter.format(fiyat).replace("₺", "");
    }
  }
};
</script>

<style>
.urun-ara-btn {
  right: -5px;
}
</style>
